const isMedMail = (email: string) => email?.endsWith('med.uni-frankfurt.de');
const isAllgemeinMedMail = (email: string) => email?.endsWith('allgemeinmedizin.uni-frankfurt.de');
export const isSDInternMail = (email: string) =>
  !isMedMail(email) && !isAllgemeinMedMail(email) && email?.endsWith('.uni-frankfurt.de');
